import './App.styles.scss';

import React from 'react';
import ProductCard from './components/product-card/ProductCard';

const App = () => {
  return <ProductCard></ProductCard>;
};

export default App;
